interface Comment {
  user: string;
  avatar: string;
  time: string;
  source: string;
  rating: string;
  content: string;
}

const comments: Comment[] = [
  {
    user: '追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20portrait%20of%20young%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20neutral%20background%2C%20soft%20expression%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    source: '《暗夜追踪》',
    rating: '9.0',
    content: '真的太好看了！剧情环环相扣，演员演技在线，已经追到第8集停不下来，强烈推荐！',
  },
  {
    user: '电影控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20portrait%20of%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20neutral%20background%2C%20calm%20expression%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    source: '《星际迷航：新纪元》',
    rating: '9.5',
    content: '特效炸裂！IMAX级别的视觉享受，剧情也比前几部更有深度，科幻迷必看。',
  },
  {
    user: '暖心小棉袄',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20portrait%20of%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20neutral%20background%2C%20friendly%20expression%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '8小时前',
    source: '《小镇故事》',
    rating: '9.0',
    content: '看哭了三次，太真实了。小人物大情怀，每一个角色都让人感同身受。',
  },
  {
    user: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20portrait%20of%20person%20with%20warm%20lighting%2C%20minimalist%20style%2C%20neutral%20background%2C%20cheerful%20expression%2C%20professional%20headshot%20quality&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '昨天',
    source: '《长安风云录》',
    rating: '8.8',
    content: '第三季比前两季更精彩，服化道太精美了，剧情反转不断，每天坐等更新！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">观众热评</h2>
            <p className="text-sm text-foreground-600 mt-1">真实观影感受 · 精彩点评分享</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {comments.map((c, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={c.avatar}
                    alt={c.user}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-foreground-950 truncate">{c.user}</div>
                    <div className="text-xs text-foreground-600">{c.time}</div>
                  </div>
                  <div className="flex items-center gap-1 shrink-0">
                    <span className="text-xs font-bold text-primary-500">{c.rating}</span>
                    <i className="ri-star-fill text-primary-500 text-xs"></i>
                  </div>
                </div>
                <div className="mb-2">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500/10 text-accent-400 text-xs whitespace-nowrap">
                    {c.source}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {c.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}